export enum OnboardingStep {
  PERSON_PF = 1,
  PERSON_PJ = 2,
  ATTACHMENTS = 3,
  PERSONALIZATION = 4,
}

export const ONBOARDING_STEP_TITLES = [
  "Informações Gerais - Pessoa Física",
  "Informações Gerais - Pessoa Jurídica",
  "Anexos - PF e PJ",
  "Personalização",
]
